import React from "react";
import { NavLink, Link } from "react-router-dom";

const SocialIcons = () => null;

export default function Nav({ active = "" }) {
  const [dark, setDark] = React.useState(() => document.body.classList.contains("dark"));

  const toggle = () => {
    document.body.classList.toggle("dark");
    setDark(document.body.classList.contains("dark"));
  };

  return (
    <nav className="kmr-nav" data-testid="kmr-nav">
      <Link to="/" className="logo-link" data-testid="nav-logo-link">
        <img src="/images/logo-black.png" alt="Komorebi" className="logo-light" />
        <img src="/images/logo-white.png" alt="Komorebi" className="logo-dark" />
      </Link>
      <div className="nav-links">
        <NavLink to="/work" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-work">Work</NavLink>
        <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-about">About</NavLink>
        <Link to="/#store" data-testid="nav-store">Store</Link>
        <Link to="/#contact" data-testid="nav-contact">Contact</Link>
        <div className="nav-dropdown" data-testid="nav-join-dropdown">
          <button className="nav-dropdown-trigger" data-testid="nav-join-trigger" aria-haspopup="true">
            Join the mission <span className="nav-caret" aria-hidden="true">▾</span>
          </button>
          <div className="nav-dropdown-menu" role="menu">
            <NavLink to="/work-alongside-us" className={({ isActive }) => "nav-dropdown-item" + (isActive ? " active" : "")} data-testid="nav-join-apply" role="menuitem">
              <span className="ddm-title">Work alongside us</span>
              <span className="ddm-sub">Apply to collaborate</span>
            </NavLink>
            <NavLink to="/creative-intelligence-session" className={({ isActive }) => "nav-dropdown-item" + (isActive ? " active" : "")} data-testid="nav-session" role="menuitem">
              <span className="ddm-title">The Creative Intelligence Session</span>
              <span className="ddm-sub">Founding cohort · Apply</span>
            </NavLink>
          </div>
        </div>
        <button className="dark-toggle" onClick={toggle} data-testid="dark-toggle-btn">
          {dark ? "Let the light in" : "Switch off the lights"}
        </button>
      </div>
    </nav>
  );
}
